import React from 'react';
import Section from './Section';
import styled from 'styled-components';
import { connect } from 'react-redux';

const Header = styled.h1`
  padding-top: 10px;
  font-size: 1.4em;
`

const Content = ({ dispatch, poseLookup }) => (

      <div>
        <Header>Intro</Header>

        <Section name="Beginning Streches" color="#1CA4FB" sectionIdentifier={0} poseIdentifiers={poseLookup[0]}/>

        <p>Transition: Flat Back, Plank, Lower to Belly</p>

        <Section name="Belly" color="#1CA4FB" sectionIdentifier={1} poseIdentifiers={poseLookup[1]}/>

        <p>Transition: Plank</p>

        <br/>
        <br/>

        <Header>Warmup Series Right Side</Header>

        <Section name="DD/Plank" color="#6BD543" sectionIdentifier={2} poseIdentifiers={poseLookup[2]}/>

        <Section name="Standing & Flying" color="#6BD543" sectionIdentifier={3} poseIdentifiers={poseLookup[3]}/>

        <Section name="Squats" color="#6BD543" sectionIdentifier={4} poseIdentifiers={poseLookup[4]}/>

        <br/>
        <br/>

        <Header>Warmup Series Left Side</Header>

        <Section name="DD/Plank" color="#6BD543" sectionIdentifier={5} poseIdentifiers={poseLookup[5]}/>

        <Section name="Standing & Flying" color="#6BD543" sectionIdentifier={6} poseIdentifiers={poseLookup[6]}/>

        <Section name="Squats" color="#6BD543" sectionIdentifier={7} poseIdentifiers={poseLookup[7]}/>


        <br/>
        <br/>

        <Header>Series 1 Right Side</Header>

        <Section name="DD/Plank" color="#EA64A7" sectionIdentifier={8} poseIdentifiers={poseLookup[8]}/>

        <Section name="Floor Moves" color="#EA64A7" sectionIdentifier={9} poseIdentifiers={poseLookup[9]}/>

        <p>Transition: DD Splits or step into lunge</p>

        <Section name="Standing & Flying" color="#EA64A7" sectionIdentifier={10} poseIdentifiers={poseLookup[10]}/>

        <Section name="Squats" color="#EA64A7" sectionIdentifier={11} poseIdentifiers={poseLookup[11]}/>

        <br/>
        <br/>

        <Header>Series 1 Left Side</Header>

        <Section name="DD/Plank" color="#EA64A7" sectionIdentifier={12} poseIdentifiers={poseLookup[12]}/>

        <Section name="Floor Moves" color="#EA64A7" sectionIdentifier={13} poseIdentifiers={poseLookup[13]}/>

        <p>Transition: DD Splits or step into lunge</p>

        <Section name="Standing & Flying" color="#EA64A7" sectionIdentifier={14} poseIdentifiers={poseLookup[14]}/>

        <Section name="Squats" color="#EA64A7" sectionIdentifier={15} poseIdentifiers={poseLookup[15]}/>

        <br/>
        <br/>

        <Header>Series 2 Right Side</Header>

        <Section name="DD/Plank" color="#FADF47" sectionIdentifier={16} poseIdentifiers={poseLookup[16]}/>

        <Section name="Floor Moves" color="#FADF47" sectionIdentifier={17} poseIdentifiers={poseLookup[17]}/>

        <p>Transition: DD Splits or step into lunge</p>

        <Section name="Standing & Flying" color="#FADF47" sectionIdentifier={18} poseIdentifiers={poseLookup[18]}/>

        <Section name="Squats" color="#FADF47" sectionIdentifier={19} poseIdentifiers={poseLookup[19]}/>

        <br/>
        <br/>

        <Header>Series 2 Left Side</Header>

        <Section name="DD/Plank" color="#FADF47" sectionIdentifier={20} poseIdentifiers={poseLookup[20]}/>

        <Section name="Floor Moves" color="#FADF47" sectionIdentifier={21} poseIdentifiers={poseLookup[21]}/>

        <p>Transition: DD Splits or step into lunge</p>

        <Section name="Standing & Flying" color="#FADF47" sectionIdentifier={22} poseIdentifiers={poseLookup[22]}/>

        <Section name="Squats" color="#FADF47" sectionIdentifier={23} poseIdentifiers={poseLookup[23]}/>

        <br/>
        <br/>

        <Header>Abs/Cooldown</Header>

        <Section name="Abs" color="#3CE5CE" sectionIdentifier={24} poseIdentifiers={poseLookup[24]}/>

        <Section name="Cooldown" color="#3CE5CE" sectionIdentifier={25} poseIdentifiers={poseLookup[25]}/>

        <br/>
        <br/>

      </div>

)

export default connect()(Content);



// WEBPACK FOOTER //
// ./src/Content.js